var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useSwipeable } from "react-swipeable";
import styled from "styled-components";
import colors from "../../designSystem/colors";
import sizes from "../../designSystem/sizes";
import { useBoundingclientrect } from "../../hooks/useBoundingclientrect";
import useScreenSize from "../../hooks/useScreenSize";
import useElementScroll from "../../hooks/useElementScroll";
import useElementSize from "../../hooks/useElementSize";
var DesktopIndicatorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: fixed;\n  left: 40px;\n  top: calc(", " - 120px);\n  height: 240px;\n  z-index: 1000;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: fixed;\n  left: 40px;\n  top: calc(", " - 120px);\n  height: 240px;\n  z-index: 1000;\n"])), function (props) { return (props.top ? props.top + "px" : "50%"); });
var DesktopIndicatorBar = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  width: 4px;\n  transition: 0.4s all ease-out;\n  background: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 16px;\n  }\n"], ["\n  flex: 1;\n  width: 4px;\n  transition: 0.4s all ease-out;\n  background: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 16px;\n  }\n"])), function (props) { return (props.active ? "white" : colors.background.four); });
var MobileIndicatorContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  position: fixed;\n  top: ", ";\n  height: 4px;\n  width: 100%;\n  background: ", ";\n"], ["\n  display: flex;\n  position: fixed;\n  top: ", ";\n  height: 4px;\n  width: 100%;\n  background: ", ";\n"])), function (props) { return (props.top ? props.top + "px" : "0"); }, colors.background.two);
var MobileIndicatorBar = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 4px;\n  width: ", "px;\n  background: white;\n"], ["\n  height: 4px;\n  width: ", "px;\n  background: white;\n"])), function (props) { return props.width; });
var SnapScrollSection = function (_a) {
    var items = _a.items, height = _a.height, className = _a.className, props = __rest(_a, ["items", "height", "className"]);
    var width = useScreenSize().width;
    var containerRef = useRef(null);
    var containerBoundingRect = useBoundingclientrect(containerRef);
    var containerBottom = useElementScroll(containerRef).scrollX.bottom;
    var containerScrolleight = useElementSize(containerRef).scrollHeight;
    var _b = useState(0), setLastWheelEventTime = _b[1];
    var itemRefs = useMemo(function () {
        return __spreadArray([], new Array(items.length)).reduce(function (acc, _curr, index) {
            acc[index] = React.createRef();
            return acc;
        }, {});
    }, [items.length]);
    var allowPagination = useMemo(function () {
        return width > sizes.lg;
    }, [width]);
    var _c = useState(0), itemIndex = _c[0], setItemIndex = _c[1];
    var _d = useState({ timestamp: 0, executed: true }), scrollEvent = _d[0], setScrollEvent = _d[1];
    /**
     * Scroll to item index
     */
    useEffect(function () {
        var _a;
        if (containerRef.current) {
            containerRef.current.scrollTo({
                top: (_a = itemRefs[itemIndex].current) === null || _a === void 0 ? void 0 : _a.offsetTop,
                behavior: "smooth",
            });
        }
    }, [itemIndex, itemRefs]);
    var handleScrollUp = useCallback(function () {
        if (!allowPagination)
            return;
        setItemIndex(function (curr) {
            // Unable to scroll further to the top
            if (curr <= 0) {
                return 0;
            }
            return curr - 1;
        });
    }, [allowPagination]);
    var handleScrollDown = useCallback(function () {
        if (!allowPagination)
            return;
        setItemIndex(function (curr) {
            // Unable to scroll further to the bottom
            if (curr + 1 >= Object.keys(itemRefs).length) {
                return Object.keys(itemRefs).length - 1;
            }
            return curr + 1;
        });
    }, [allowPagination, itemRefs]);
    /**
     * Handle mobile swipe
     */
    var handlers = useSwipeable({
        onSwipedUp: handleScrollDown,
        onSwipedDown: handleScrollUp,
    });
    /**
     * Handle desktop wheel event
     */
    var handleWheel = useCallback(function (e) {
        // Ignore small delta movement
        if (e.deltaY > -25 && e.deltaY < 25) {
            return;
        }
        setLastWheelEventTime(function (_lastWheelEventTime) {
            // We make sure the current event are not continuity of the last event fired
            if (e.timeStamp - _lastWheelEventTime > 50) {
                setScrollEvent(function (curr) {
                    /**
                     * Accept a scroll event every 500ms
                     */
                    if (e.timeStamp - 500 <= curr.timestamp || e.deltaY === 0) {
                        return curr;
                    }
                    return {
                        timestamp: e.timeStamp,
                        event: e.deltaY > 0 ? "down" : "up",
                        executed: false,
                    };
                });
            }
            return e.timeStamp;
        });
    }, []);
    /**
     * Register wheel event
     */
    useEffect(function () {
        var element = containerRef.current;
        if (element) {
            element.addEventListener("wheel", handleWheel);
            return function () {
                element === null || element === void 0 ? void 0 : element.removeEventListener("wheel", handleWheel);
            };
        }
    }, [handleWheel]);
    /**
     * Perform scroll event when it had changed
     */
    useEffect(function () {
        if (scrollEvent.executed) {
            return;
        }
        switch (scrollEvent.event) {
            case "down":
                handleScrollDown();
                break;
            case "up":
                handleScrollUp();
                break;
        }
        setScrollEvent(function (curr) { return (__assign(__assign({}, curr), { executed: true })); });
    }, [handleScrollDown, handleScrollUp, scrollEvent]);
    /**
     * For ref sharing
     */
    var refPassthrough = useCallback(function (el) {
        // call useSwipeable ref prop with el
        handlers.ref(el);
        // set myRef el so you can access it yourself
        containerRef.current = el;
    }, [handlers]);
    return (_jsxs("div", __assign({}, props, { ref: refPassthrough, className: "d-flex flex-wrap w-100 " + (allowPagination ? "position-fixed overflow-hidden" : "") + " " + (className || ""), style: { height: height, top: 0, left: 0 } }, { children: [width > sizes.xl ? (_jsx(DesktopIndicatorContainer, __assign({ top: containerBoundingRect
                    ? containerBoundingRect.top + containerBoundingRect.height / 2
                    : undefined }, { children: items.map(function (item, index) {
                    if (item.anchor !== false) {
                        return (_jsx(DesktopIndicatorBar, { active: index === itemIndex, role: "button", onClick: function () { return setItemIndex(index); } }, index));
                    }
                    return null;
                }) }), void 0)) : (_jsx(MobileIndicatorContainer, __assign({ top: containerBoundingRect === null || containerBoundingRect === void 0 ? void 0 : containerBoundingRect.top }, { children: _jsx(MobileIndicatorBar, { width: containerBoundingRect
                        ? containerBoundingRect.width *
                            ((containerScrolleight - containerBottom) /
                                containerScrolleight)
                        : 0 }, void 0) }), void 0)), items.map(function (item, index) { return (_jsx("div", __assign({ ref: itemRefs[index], className: "d-flex w-100 " + (item.containerClassName || "") }, { children: item.child }), index)); })] }), void 0));
};
export default SnapScrollSection;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=SnapScrollSection.js.map